import { CLEAR_MODAL, OPEN_MODAL } from './types'

export const clearModal = modalId => ({ type: CLEAR_MODAL, modalId })

export const openModal = (modalId, data = {}) => ({ type: OPEN_MODAL, modalId, data })
